import type { IconName } from '@w7/ui'

export interface NavItem {
  id: string
  label: string
  to: string
  icon: IconName
  adminOnly?: boolean
  description: string
}

export interface NavGroup {
  id: string
  label: string
  items: NavItem[]
}

export const NAV: NavGroup[] = [
  {
    id: 'ops',
    label: 'Operations',
    items: [
      {
        id: 'dashboard',
        label: 'Dashboard',
        to: '/sessionmarket',
        icon: 'overview',
        description: 'Session market ops',
      },
      {
        id: 'run',
        label: 'Run',
        to: '/runlist',
        icon: 'activity',
        description: 'Manage runs',
      },
      {
        id: 'rate',
        label: 'Rate',
        to: '/ratelist',
        icon: 'commission',
        description: 'Manage rates',
      },
      {
        id: 'ratecategory',
        label: 'Rate Category',
        to: '/ratecategory',
        icon: 'pnl',
        description: 'Rate categories',
      },
      {
        id: 'results',
        label: 'Results',
        to: '/resultlist',
        icon: 'net-exposure',
        description: 'Declared results',
      },
      {
        id: 'fetch',
        label: 'Fetch Market',
        to: '/fetchMarket',
        icon: 'activity',
        description: 'Browse catalog sports / competitions',
      },
      {
        id: 'pl',
        label: 'PL Details',
        to: '/pldetails',
        icon: 'transfers',
        description: 'P&L details export',
      },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    items: [
      {
        id: 'users',
        label: 'User',
        to: '/userList',
        icon: 'users',
        adminOnly: true,
        description: 'User management',
      },
      {
        id: 'submarketinfo',
        label: 'Sub Market Info',
        to: '/submarketinfo',
        icon: 'downline',
        adminOnly: true,
        description: 'Sub market info',
      },
    ],
  },
]
